export default {
    AGGREGATE_LEVELS: {
        BY_DAY: 'day',
        BY_MONTH: 'month',
        BY_YEAR: 'year',
        DAY: {
            FROM: 0,
            TO: 3,
        },
        MONTH: {
            FROM: 3,
            TO: 12,
        },
        QUARTER: {
            FROM: 12,
            TO: 36,
        },
        YEAR: {
            FROM: 36,
            TO: 9999,
        },
    },
    INFINITE_DATE: new Date('9999-01-01'),
    FIRST_DATE: new Date('1901-01-01'),
    FORMAT: {
        API_DATE: 'yyyy-MM-dd',
        UI_DATE: 'yyyy-MM-dd',

        //formats with buid in
        DATE_SHORT: 'dd-MMM-yy',
        DATE_LONG: 'dd MMMM yyyy',
        DATE_TIME_SHORT: 'dd-MMM-yy p',
        DATE_TIME_LONG: 'dd MMMM yyyy p',
        DATE_TIME_AT: 'PPPp',
        TIME: 'p',
        DAY: 'dd',

        /**
         * Custom Format
         * We need to discoureg adding new formats.
         */

        DAY_OF_WEEK: 'eee',
        MONTH: 'MMM',
        PERIOD: 'eee, MMM d',
        PERIOD_FULL: 'eee, MMM d, yyyy',
        PERIOD_FULL_TIME: 'E, MMM d, yyyy, p',
        UI_DATE_MONTH_YEAR: 'MMM-yyyy',
        UI_DATE_QUARTER_YEAR: 'QQQ/yyyy',
        UI_DATE_YEAR: 'yyyy',
        UI_TIME: 'hh:mm',
        LONG_DATE: 'dd-MMM-yyyy',
        TIMESTAMP: 'dd MMM yyyy HH:mm:ss bb',
        TIMESTAMP_TIMEZONE: 'dd MMM yyyy HH:mm:ss bb XXX',
    },
};
